import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router-dom'
import styled from 'styled-components'

import { ErrorCatSVG } from 'assets/svg/sprite'
import { Button } from 'components/Button/Button'
import DesktopAdditionalContent from 'features/DesktopAdditionalContent/DesktopAdditionalContent'
import { AllIcons } from 'helpers/allIcons'
import colors from 'styles/colors'

export const NotFound = () => {
    const navigate = useNavigate()
    const location = useLocation()
    const { t } = useTranslation()

    const pathSegments = location.pathname
        .split('/')
        .filter(Boolean)

    const isProfileRoute = pathSegments.length === 1

    return (
        <>
                <ErrorPageWrapper>
                    {/* <img src={AllIcons.bg404} alt={t('background')} /> */}
                    <ErrorPage>
                        <ErrorCatSVG />
                        <h1>404</h1>

                        <h2>
                            {isProfileRoute
                                ? t('profileNotFound')
                                : t('pageNotFound')}
                        </h2>

                        <p>
                            {isProfileRoute
                                ? t('TheProfileYouAreLookingDoesNotExist')
                                : t('ThePageYouAreLookingForMightHaveBeenRemoved')}
                        </p>

                    <Button
                        text={t('goBack')}
                        color='black'
                        font='mont-14-bold'
                        width='20'
                        height='5'
                        clickFn={() => {
                            navigate(-1)
                        }}
                    />
                    </ErrorPage>
                </ErrorPageWrapper>

            <DesktopAdditionalContent />
        </>
    )
}

const ErrorPageWrapper = styled.div`
    position: relative;
    width: 100%;
    min-height: 100vh;
    min-height: 100dvh;
    overflow: hidden;

/*     background:
        linear-gradient(
            90deg,
            #f6f6f6 0%,
            #ffffff 51.09%,
            #efefef 100%
        ),
        #f2f6f9; */
        background-color: #fff;
    > img {
        position: absolute;
        inset: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
        pointer-events: none;
    }
`

const ErrorPage = styled.div`
    position: relative;
    z-index: 1;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    width: 100%;
    min-height: 100vh;
    min-height: calc(100dvh - 6rem);
    box-sizing: border-box;
    text-align: center;
    @media (min-width: 965px) {
        min-height: calc(100dvh - 8rem);
        justify-content: flex-start;
        padding-top: 8vh;
    }
    h1 {
        font-size: 13rem;
        line-height: 1;
        font-weight: 500;
        color: #181920;
        margin: 2rem 0;
        margin-bottom:1rem;
        @media (max-width: 965px) {
            font-size: 9rem;
        }
    }

    h2 {
        font-size: 2rem;
        font-weight:600;
        font-variation-settings: 'wght' 650;
        color: ${colors.blueDark};
        line-height: 2.9rem;
        margin: 0;
    }

    p {
        max-width: 42rem;
        font-size: 1.4rem;
        font-weight: 500;
        line-height: 140%;
        color: ${colors.stormyBlue};
        margin: 2rem 0;
        text-align: center;
        padding-left:2rem;
        padding-right:2rem;
        @media (max-width: 965px) {
            font-size: 1.2rem;
        }
    }

`